import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSurfingNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M22.289 1.71c-.243-.242-.562-.394-.853-.49a4.483 4.483 0 00-1.083-.204c-.817-.06-1.857.037-3.085.398-2.458.723-5.698 2.514-9.506 6.322C1.98 13.519.708 17.98.541 18.666c-.095.386.03.775.29 1.036L4.3 23.168c.26.26.65.384 1.035.29.482-.118 2.84-.784 6.215-3.19 1.41 2.056 4.444 2.357 6.22.448l.06-.066c1.485 1.726 4.246 1.887 5.903.105l-1.464-1.362a1.964 1.964 0 01-3.219-.51l-.142-.306a1 1 0 00-1.64-.26l-.963 1.037a2 2 0 01-3.16-.3 39.8 39.8 0 003.12-2.817c.284-.284.556-.564.818-.841l.131.282c1.063 2.284 3.87 2.965 5.843 1.646l.831-.556-1.111-1.662-.832.555a2.002 2.002 0 01-2.917-.826l-.497-1.069c2.29-2.749 3.495-5.128 4.056-7.036.36-1.227.457-2.267.397-3.085-.03-.407-.1-.772-.203-1.082-.097-.291-.248-.61-.491-.853zM9.177 9.15c3.634-3.635 6.596-5.21 8.656-5.817 1.032-.303 1.83-.362 2.375-.322a2.512 2.512 0 01.654.127l.021.058c.042.126.086.323.106.596.04.545-.019 1.343-.322 2.375-.606 2.06-2.182 5.022-5.817 8.656-4.597 4.597-8.234 6.123-9.517 6.552l-.647-.647 12.97-12.97-1.413-1.414-12.97 12.97-.648-.647c.429-1.283 1.955-4.92 6.552-9.517z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSurfingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSurfingNormalSmall;
